export const UploadFileTypes = {
  pdf: 'application/pdf',
  png: 'image/*'
}



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-file-upload/src/file-upload.constants.js